import CreatedUserIcon from '../../../../assets/icons/CreatedUser.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import QuestionMarkIcon from '../../../../assets/icons/QuestionMark.svg';
import ChronometerIcon from '../../../../assets/icons/ChronoMeter.svg';
import ATSessionsIcon from '../../../../assets/icons/ATSessions.svg';
import AuthContext from '../../../../auth/AuthContext';

const AssessmentTypeCard = ({ data }) => {
    const navigate = useNavigate();
    const { assessmentName } = useParams();
    const authContext = useContext(AuthContext);
    const [permissions, setPermissions] = useState({});

    const minutesToTime = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    }

    const onEditHandler = (e) => {
        e.preventDefault();
         sessionStorage.setItem("assessmentId", data.id);
        if (data.type === 'MCQ') {
            navigate(`/masters-assessments/${assessmentName}/mcq`, { state: { id: data.id } });
        } else {
            navigate(`/masters-assessments/${assessmentName}/practical`, { state: { id: data.id } });
        }
    }

  const onSessionClickHandler = (e) => { 
  e.preventDefault();
  sessionStorage.setItem("assessmentId", data.id);
  navigate(
    `/masters-assessments/${assessmentName}/${data.type.toLowerCase()}-sessions`,
    { state: { id: data.id } }
  );
};


    const onAttendeeClickHandler = (e) => {
        e.preventDefault();
        sessionStorage.setItem("assessmentId", data.id);
        navigate(`/masters-assessments/${assessmentName}/${data.type.toLowerCase()}-attendees`, { state: { id: data.id } });
    }

    useEffect(() => {
        const assessmentAccess = authContext.getPermissions("assessmentsmaster");
        if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
            navigate("/");
        }
        setPermissions({
            showAdd: assessmentAccess.some(f => f.access.includes(2)),
            showEdit: assessmentAccess.some(f => f.access.includes(3)),
            showDelete: assessmentAccess.some(f => f.access.includes(4)),
        });
    }, [authContext, navigate]);

    return (
        <div className="card border-0 shadow-sm p-3 p-lg-4 h-100"
            style={{minHeight: "100px" }}
        >
<div
  className="d-flex flex-row align-items-center gap-3 rounded"
  style={{
    color: '#fff',
    minHeight: '87px',
    backgroundImage: `url('./../../../../assets/icons/ATHeader.svg')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
  <h6 className="ms-3 mb-0 lh-base">{data.type}</h6>
</div>


            <div className="progress mt-3" style={{ "height": "10px" }}>
                <div className="progress-bar" role="progressbar" style={{ "width": `${data.attendeePercent}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div className="d-flex justify-content-left mb-3">
                <div className="fw-light" style={{ fontSize: "13px" }}>
                    {data.totalAttendees}/{data.totalUsers}
                </div>
            </div>
            <div className="d-flex justify-content-between mb-4">
                <div className="fw-light" title='No of Questions'>
                    <img
                        src={QuestionMarkIcon}
                        alt="No of Questions"
                        className="w-4 h-4 hover:opacity-70 me-1 mb-1"
                    /> {data.totalQuestions}
                </div>
                <div className="fw-light" title='Duration'>
                    <img
                        src={ChronometerIcon}
                        alt="Duration"
                        className="w-4 h-4 hover:opacity-70 me-1 mb-1"
                    /> {minutesToTime(data.duration)}
                </div>
            </div>
            <div className="d-flex justify-content-between mb-4">
                <button className="card-btn-link fw-light text-primary"
                    onClick={onSessionClickHandler}
                ><img
                        src={ATSessionsIcon}
                        alt="Sessions"
                        className="w-4 h-4 hover:opacity-70  me-2 mb-1"
                    />Sessions
                </button>
                <button className="card-btn-link fw-light text-primary"
                    onClick={onAttendeeClickHandler}
                ><img
                        src={CreatedUserIcon}
                        alt="Attendees"
                        className="w-4 h-4 hover:opacity-70  me-2"
                    />Attendees
                </button>
            </div>
            {permissions.showEdit && <div className="d-flex justify-content-center mb-1">
                <button
                    className="px-5 py-2 rounded-pill btn btn-outline"
                    style={{
                        width: '100%'
                    }}
                    onClick={onEditHandler}
                >
                    Edit
                </button>
            </div>}
        </div>
    );
}

export default AssessmentTypeCard;